export const PARTNER_FORM = {
  partnerForm: document.querySelector('#aafp_add-new-partner') as HTMLFormElement,
  partnerName: document.querySelector('#aafp_form-partner-name') as HTMLInputElement,
  partnerAccountNumber: document.querySelector('#aafp_form-partner-account-number') as HTMLInputElement,
  partnerFileType: document.querySelector('#aafp_dropdown-button-file') as HTMLElement,
  partnerSubmit: document.querySelector('#aafp_partner-new-submit') as HTMLInputElement
}

export const EXPORT_FILE_TYPE = [
  { id: 'CSV', name: 'CSV' },
  { id: 'XML', name: 'XML' }
];